import 'jquery';
import 'bootstrap/dist/js/bootstrap';

import lightGallery from '../lib/lightgallery/js/lightgallery.js';

require('../lib/justified_gallery/jquery.justifiedGallery.min.js');

import {settings} from './variables.js'

var Flickity = require('flickity');
require('flickity-imagesloaded');

require('./ajax.js');
require('./search.js');


var staticBase = settings.staticBase

function logo_responsive() {
    if (jQuery(window).width() < 768) {
        jQuery(".logo img").attr("src", staticBase+"images/logo-horiz.png");
    } else {
        jQuery(".logo img").attr("src", staticBase+"images/logo_rosrent-01.png?3");
    }
}

var h_main = jQuery(".inner-layout .main").height();

$(".search-desktop__get-form-btn").click(function () {
    jQuery(this).parent().find(".search-field").addClass("search-field--expand")
})

jQuery(document).ready(function() {
    logo_responsive();

    if (jQuery(window).height() > h_main) {
        jQuery(".inner-layout").addClass("long-layout");
    }
    $('.gallery-anons .photos').justifiedGallery({
        margins : 4,
        lastRow : 'justify'
    });

    $('.photos-detail').justifiedGallery({
        margins : 5,
        rowHeight : 200,
        lastRow : 'justify'
    }).on('jg.complete', function (e){

    });

    if (jQuery('.lightgallery').length) {
      jQuery(".lightgallery").lightGallery({
        selector: '.gallery-item-n',
        pager: true,
        download: false
      });
    }

    if (jQuery('#div_id_horny_email').length){
        jQuery('#div_id_horny_email').hide();
    }
    if (jQuery('.horny-widget').length){
        jQuery('.horny-widget').parent('div').hide();
    }
    if (jQuery('#div_id_horny_email_consult').length){
        jQuery('#div_id_horny_email_consult').hide();
    }

    if (jQuery(".new-carousel").length) {
        var flkty = new Flickity( '.new-carousel', {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            imagesLoaded: true,
            wrapAround: true
        });
    }

});

jQuery(window).resize(function() {
    logo_responsive();
});


jQuery('.lk-top .navbar-toggle').click(function () {
    jQuery('.sidebar').css('transform', 'translate3d(0, 0, 0)');
});

if (jQuery(window).width() < 767) {
    jQuery('.navbar-close').click(function () {
        jQuery('.sidebar').css('transform', 'translate3d(-243px, 0, 0)');
    });
} else {
    jQuery('.navbar-close').click(function () {
        jQuery('.sidebar').css('width', '53px');
        jQuery('.lk-nav ul li a span').css('display', 'none');
        jQuery('.contacts').css('display', 'none');
        jQuery(this).css('display', 'none');
    });
}

if (jQuery(window).width() > 767) {
    jQuery('.navbar-toggle').click(function () {
        jQuery('.sidebar').css('width', '243px');
        jQuery('.navbar-close').css('display', 'block');
        jQuery('.lk-nav ul li a span').css('display', 'inline-block');
        jQuery('.contacts').css('display', 'block');
    });
}
